import {Component} from "@angular/core";
import SwaggerUI from "swagger-ui";
import {WebmateOptions} from "@webmate-web-core/webmate-options";

@Component({
    standalone: true,
    templateUrl: './swagger-ui.component.html'
})
export class SwaggerUiComponent {

    constructor(private webmateOptions: WebmateOptions) {}

    ngOnInit() {
        SwaggerUI({
            dom_id: '#swagger-ui',
            url: this.webmateOptions.baseApiUri + '/swagger-files/swagger.json'
        });
    }
}
